export default "__VITE_ASSET__Or7ieLfM__"